import React, { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faUser, faArrowRight, faSpinner } from "@fortawesome/free-solid-svg-icons";

import { Container, Row, Col, Form, InputGroup, Alert } from 'react-bootstrap';
import Image from 'react-bootstrap/Image';
import Button from 'react-bootstrap/Button';

import axios from 'axios';

import './contact.scss';

function Contact() {
  const [formData, setFormData] = useState({
    email: '',
    fullName: '',
    message: '',
  });

  const [errors, setErrors] = useState({});
  const [showAlert, setShowAlert] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const validateForm = () => {
    const newErrors = {};

    // Validate email format
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else {
      if (!emailRegex.test(formData.email)) {
        newErrors.email = 'Invalid email address';
      }
    }

    // Validate full name (required)
    if (!formData.fullName.trim()) {
      newErrors.fullName = 'Full name is required';
    }

    // Validate message (required)
    if (!formData.message.trim()) {
      newErrors.message = 'Message is required';
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const apiUrl = process.env.REACT_APP_API_BASE_URL + '/contact.php';

  const displayAlert = () => {
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
    }, 5000); // Hide the alert after 5 seconds
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      // Set the form submission state to true
      setIsSubmitting(true);
      // Send the email using Axios
      axios.post(apiUrl, formData, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        if (response.data.status === "success") {
          console.log(response.data.message);
          // Display the success alert
          displayAlert();
          // Clear the form fields
          setFormData({
            email: '',
            fullName: '',
            message: '',
          });
        } else {
          console.error(response.data.message);
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(() => {
        setIsSubmitting(false); // Set the form submission state back to false
      });
    }
  };

  return (
    <>
      {/* Banner section */}
      <section id="banner">
        <Image src="/images/contact-banner.webp" alt="Contact Banner" className="w-100" />
        <div className="banner-content">
          <h1>Contact Us</h1>
        </div>
      </section>

      {/* Contact info section */}
      <section id="contactInfoSection">
        <Container>
          <Row>
            <Col md={6}>
              <Row>                
                <Col className="p-0">
                  <Image src="/images/rafiki.webp" alt="About Image" className="img-fluid"/>
                  <h4 className="text-center m-0 d-block d-md-none mt-3" style={{fontSize: "18px"}}>Get In Touch With Us</h4>
                  <p className="text-center m-0 d-block d-md-none mb-4" style={{fontSize: "14px"}}>Reach out to us for any inquiry</p>
                  <ul className="d-none d-md-block">
                    <li>
                      <span>
                        <Image src="/images/icons/whatsapp.png" alt="Whatsapp Icon"/>
                      </span>
                      <span>
                        <a href="tel:94717296004" target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>+94 71 729 6004</a>
                      </span>
                    </li>
                    <li>
                      <span>
                        <Image src="/images/icons/envelop.png" alt="Envelop Icon"/>
                      </span>
                      <span>
                        <a href={`mailto:info@plantslk.com`} style={{ textDecoration: 'none' }}>info@plantslk.com</a>
                      </span>
                    </li>
                    <li>
                      <span>
                        <Image src="/images/icons/location.png" alt="Location Icon"/>
                      </span>
                      <span>
                        <a href='https://goo.gl/maps/r5p5vUPqTtmLEjuw7' target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>No. 73/A, Negombo Road, Kurana, Katunayake</a>
                      </span>
                    </li>
                  </ul>
                </Col>
              </Row>
            </Col>
            <Col md={6}>
              <h4 className="d-none d-md-block">Get In Touch With Us</h4>
              <p className="d-none d-md-block">Reach out to us for any inquiry</p>

              <Row>
                <Col xs={12} lg={8}>
                  {/* Success message alert */}
                  {showAlert && (
                    <Alert variant="success" className="mt-3">
                      Message sent successfully!
                    </Alert>
                  )}
                  <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="email">
                      <Form.Label>Email<span className="text-danger">*</span></Form.Label>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="example@gmail.com"
                        />
                        <InputGroup.Text>
                          <FontAwesomeIcon icon={faEnvelope} />
                        </InputGroup.Text>
                      </InputGroup>
                      {errors.email && <div className="text-danger">{errors.email}</div>}
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="full_name">
                      <Form.Label>Full Name<span className="text-danger">*</span></Form.Label>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="fullName"
                          value={formData.fullName}
                          onChange={handleChange}
                          placeholder="Adam Smith"
                        />
                        <InputGroup.Text>
                          <FontAwesomeIcon icon={faUser} />
                        </InputGroup.Text>
                      </InputGroup>
                      {errors.fullName && <div className="text-danger">{errors.fullName}</div>}
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="message">
                      <Form.Label>Message<span className="text-danger">*</span></Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        placeholder="Enter your message"
                      />
                      {errors.message && <div className="text-danger">{errors.message}</div>}
                    </Form.Group>

                    {/* Buttons for submitting */}
                    <div className="d-flex justify-content-center justify-content-md-start mt-3">
                      <Button
                        type="submit"
                        className={`w-50 ${isSubmitting ? 'd-none' : ''}`}
                        onClick={handleSubmit}
                      >
                        Send Message <FontAwesomeIcon icon={faArrowRight}/>
                      </Button>
                      <Button
                        type="submit"
                        className={`w-50 ${isSubmitting ? '' : 'd-none'}`}
                        disabled
                      >
                        Sending <FontAwesomeIcon icon={faSpinner} spin/>
                      </Button>
                    </div>
                  </Form>

                  <ul className="d-md-none mt-5 p-0">
                    <li>
                      <span>
                        <Image src="/images/icons/whatsapp.png" alt="Whatsapp Icon"/>
                      </span>
                      <span>
                        <a href="tel:94717296004" target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>+94 71 729 6004</a>
                      </span>
                    </li>
                    <li>
                      <span>
                        <Image src="/images/icons/envelop.png" alt="Envelop Icon"/>
                      </span>
                      <span>
                        <a href={`mailto:info@plantslk.com`} style={{ textDecoration: 'none' }}>info@plantslk.com</a>
                      </span>
                    </li>
                    <li className="mb-0">
                      <span>
                        <Image src="/images/icons/location.png" alt="Location Icon"/>
                      </span>
                      <span>
                        <a href='https://goo.gl/maps/r5p5vUPqTtmLEjuw7' target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>No. 73/A, Negombo Road, Kurana, Katunayake</a>
                      </span>
                    </li>
                  </ul>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default Contact;